import { ProblemNotice } from "@quovy/ui";
import { Input } from "@quovy/ui/input";

import type { EndpointPairValue } from "../lib/environment-endpoints";
import { endpointPairValid } from "../lib/environment-endpoints";

// Operators type bare hosts (sep07: "app.57.165.54.113.nip.io"); the contract
// wants an origin, so add the scheme on blur instead of rejecting the field.
function withScheme(value: string): string {
  return value && !/^https?:/i.test(value) ? `https://${value}` : value;
}

export function EndpointPairFields({
  idPrefix,
  value,
  onChange,
  autoFocus = false,
}: {
  idPrefix: string;
  value: EndpointPairValue;
  onChange: (value: EndpointPairValue) => void;
  autoFocus?: boolean;
}) {
  const valid = endpointPairValid(value);
  return (
    <div className="grid gap-3">
      <div className="grid gap-2">
        <label htmlFor={`${idPrefix}-web-origin`} className="text-sm font-medium">
          Web origin
        </label>
        <Input
          id={`${idPrefix}-web-origin`}
          value={value.webOrigin}
          placeholder="https://app.customer.example"
          autoComplete="off"
          autoFocus={autoFocus}
          onChange={(event) => onChange({ ...value, webOrigin: event.target.value.trim() })}
          onBlur={() => onChange({ ...value, webOrigin: withScheme(value.webOrigin) })}
        />
      </div>
      <div className="grid gap-2">
        <label htmlFor={`${idPrefix}-api-origin`} className="text-sm font-medium">
          API origin
        </label>
        <Input
          id={`${idPrefix}-api-origin`}
          value={value.apiOrigin}
          placeholder="https://api.customer.example"
          autoComplete="off"
          onChange={(event) => onChange({ ...value, apiOrigin: event.target.value.trim() })}
          onBlur={() => onChange({ ...value, apiOrigin: withScheme(value.apiOrigin) })}
        />
      </div>
      {!valid ? (
        <ProblemNotice
          title="Endpoint pair is invalid"
          howToResolve="Enter both origins in the form https://app.customer.example and https://api.customer.example (a DNS name, HTTPS on port 443, no path), or clear both fields."
          resolution={{ kind: "in-place" }}
        >
          One or both origins are missing or do not match the deployment contract. Web and API
          origins configure one cookie, CORS, callback, and Ingress contract and cannot be saved
          independently.
        </ProblemNotice>
      ) : null}
    </div>
  );
}
